import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import interceptorsResponseState from './state';
export const interceptorsResponseSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => interceptorsResponseState);
    },
    initialState: interceptorsResponseState,
    name: 'interceptorsResponse',
    reducers: {
        initializeResponseInterceptors: state => {
            state.interceptorsInitialized = true;
        },
        resetGatewayTimeout: state => {
            state.gatewayTimeout = false;
        },
        resetInterceptorsResponses: () => interceptorsResponseState,
        setAuthorized: state => {
            state.unauthorized = false;
        },
        setGatewayTimeout: state => {
            state.gatewayTimeout = true;
        },
        setUnauthorized: state => {
            state.unauthorized = true;
        }
    }
});
export const { initializeResponseInterceptors, resetGatewayTimeout, resetInterceptorsResponses, setAuthorized, setGatewayTimeout, setUnauthorized } = interceptorsResponseSlice.actions;
export default interceptorsResponseSlice.reducer;
